import React from 'react';

const OperationProgressBar = ({ elapsedTimeSeconds, estimatedTotalHours }) => {
  const estimatedTotalSeconds = estimatedTotalHours * 3600;
  const progressPercentage = estimatedTotalSeconds > 0
    ? Math.min(100, (elapsedTimeSeconds / estimatedTotalSeconds) * 100)
    : 0;

  return (
    <div className="w-full bg-gray-200 rounded-lg h-3 mt-2 overflow-hidden shadow-inner">
      <div
        className="h-full rounded-lg bg-gradient-to-r from-indigo-500 to-purple-600 transition-all duration-500 ease-out"
        style={{ width: `${progressPercentage}%` }}
      ></div>
    </div>
  );
};

export default OperationProgressBar;

// DONE